<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.roleType" clearable placeholder="展示对象">
                        <el-option
                            v-for="item in roleTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.moduleTitle" placeholder="功能名称"></el-input>
                </div>
            </div> 
            <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAdd()">新增</el-button>
            </div>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                v-loading="loading"
                element-loading-text = "数据正在加载中..."
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="roleType" label="展示对象" width="90px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.roleType == 1">
                            家长
                        </div>
                        <div v-else-if="scope.row.roleType == 2">
                            教职
                        </div>
                        <div v-else>
                            家长,教职
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="功能LOGO"  :show-overflow-tooltip="true" width="90px" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.moduleIcon != null && scope.row.moduleIcon != ''">
                            <el-popover
                                placement="right"
                                title=""
                                trigger="hover">
                                <img :src="scope.row.moduleIcon" lazy="loading"
                                    style="max-height:250px; max-width:330px"/>
                                <img slot="reference" :src="scope.row.moduleIcon"  lazy="loading" :alt="scope.row.moduleIcon" style="max-height: 50px;max-width: 130px">
                            </el-popover>
                        </div>
                        <div v-else>
                            未上传
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="moduleTitle" label="功能名称" :show-overflow-tooltip="true" width="90px"></el-table-column>
                <el-table-column prop="moduleTitleByname" label="功能别名" :show-overflow-tooltip="true" width="90px"></el-table-column>
                <el-table-column prop="commonName" label="绑定五育指标" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.commonName != null">
                            {{scope.row.commonName}}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="moduleStatus" label="功能状态" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.moduleStatus == 0">
                            <span style="color:red">禁用</span>
                        </div>
                        <div v-else-if="scope.row.moduleStatus == 1">
                            启用
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="拥有权限者" :show-overflow-tooltip="true" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.showUserRoster == '' || scope.row.showUserRoster == null">
                            全部人员
                        </div>
                        <div v-else>
                            {{scope.row.showUserRosterName}}
                        </div>
                    </template>
                </el-table-column>
                 <el-table-column prop="" label="无权限者" :show-overflow-tooltip="true" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.notshowUserRoster == '' || scope.row.notshowUserRoster == null">
                            无
                        </div>
                        <div v-else>
                            {{scope.row.commonName2}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="orderNum" label="排序号" width="60"></el-table-column>
                <el-table-column fixed="right" label="操作" width="110px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button  v-if="scope.row.moduleStatus == 0"
                            @click.native.prevent="setStatus(scope.row,1)"
                            type="text"
                            size="small" style="color: #387EE8;">
                            启用
                        </el-button>
                        <el-button  v-if="scope.row.moduleStatus == 1"
                            @click.native.prevent="setStatus(scope.row,0)"
                            type="text"
                            size="small" style="color: red" >
                            停用
                        </el-button>
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
    </div>
</template>

<script>
    import { array } from 'js-md5';
import http from '../../../../common/http'; 
    import add from './Add.vue';
    import update from './Update.vue';

    export default {
        name:"ModuleConfig",
        data(){
            return{
                menuName:"",
                loading:false,
                addVisible:false,
                updateVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    deptId:"",
                    moduleStatus:"",
                    moduleTitle:"",
                    roleType:"",
                    evaluateId:""
                },
                data:[],
                depts:[],
                roleTypes:[{
                    value: 0,
                    label: '全部'
                },{
                    value: 1,
                    label: '家长'
                },{
                    value: 2,
                    label: '教职'
                }],
                moduleConfigNames:""
            }
        },
        components: {
            add,update
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                let url  = this.moduleConfigListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    moduleTitle:this.form.moduleTitle,
                    roleType:(this.form.roleType=='0'?'':this.form.roleType)
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.data = res.data.list;
                        this.common.total=res.data.total;

                        // 遍历名称，然后将列表赋值到模块字符串
                        let moduleConfigArr = new Array()
                        for(let i=0;i<this.data.length;i++){
                            moduleConfigArr.push(this.data[i].moduleTitle)
                        }
                        this.moduleConfigNames = moduleConfigArr.join(',')
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //新增界面
            setAdd(){
                this.addVisible=true
                this.$nextTick(() => {
                    console.log('进入新增界面', this.moduleConfigNames)
                    this.$refs['add'].init(this.form.deptId, this.moduleConfigNames)
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    console.log('进入修改界面', this.moduleConfigNames)
                    this.$refs['update'].init(data, this.moduleConfigNames);
                })
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.moduleConfigRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },// 启用/停用
            setStatus(row,status){
                this.form.id = row.id;
                this.form.evaluateId = row.commonId
                this.form.moduleStatus=status;
                if(status == 1){
                    this.updateStatusSuccess();
                }else if(status == 0){
                    let msg="此操作将功能停用，导致移动端无法显示该功能，是否继续？";
                    this.$commonFn.showConfirm2(msg,this.updateStatusSuccess);
                }
            },
            updateStatusSuccess(){
                let url  = this.moduleConfigUpdateStatusUrl;
                let data = {
                    id:this.form.id,
                    evaluateId:this.form.evaluateId,
                    moduleStatus:this.form.moduleStatus
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/moduleconfig/ModuleConfig.vue